import React from 'react'

import type { MenuContentBlock } from '@library/api-menu-experience'

import { renderContentBlocks } from './renderContentBlocks'

type BrowseScreenWrapperProps = {
  contentBlocks: MenuContentBlock[]
}

export const BrowseScreenWrapper = ({ contentBlocks }: BrowseScreenWrapperProps) => (
  <div data-testid="menu-experience-browse-screen">{renderContentBlocks(contentBlocks)}</div>
)
